<template>
  <b-container>
    <div class="d-flex justify-content-center">
      <h1>MLB App Tools</h1>
    </div>
    <b-row class="card-holder">
      <b-card-group deck>
        <feature name="configs">
          <router-link
            tag="p"
            class="tool-link"
            to="/configs">
            <b-card
              v-if="canConfigsView"
              class="zoom-card tool-card flex-column justify-content-center shadow m-2"
              border-variant="primary"
              align="center">
              <b-img
                class="card-icon"
                height="32"
                width="32"
                src="/img/icons/app-config.svg" />
              <p class="card-text mt-1">
                App Config
              </p>
            </b-card>
          </router-link>
        </feature>
        <feature name="app-navigation">
          <router-link
            tag="p"
            class="tool-link"
            to="/app-navigation">
            <b-card
              v-if="canAppNavigationView"
              class="zoom-card tool-card flex-column justify-content-center shadow m-2"
              border-variant="primary"
              align="center">
              <i class="card-icon fas fa-bars fa-2x" />
              <p class="card-text mt-1">
                App Navigation
              </p>
            </b-card>
          </router-link>
        </feature>
        <feature name="asset-manager">
          <router-link
            tag="p"
            class="tool-link"
            to="/assets">
            <b-card
              v-if="canAssetManagerView"
              class="zoom-card tool-card flex-column justify-content-center shadow m-2"
              border-variant="primary"
              align="center">
              <i class="card-icon fas fa-images fa-2x" />
              <p class="card-text mt-1">
                Asset Manager
              </p>
            </b-card>
          </router-link>
        </feature>
        <feature name="banners">
          <router-link
            tag="p"
            class="tool-link"
            to="/banners">
            <b-card
              v-if="canBannersView"
              class="zoom-card tool-card flex-column justify-content-center shadow m-2"
              border-variant="primary"
              align="center">
              <i class="card-icon fas fa-flag fa-2x" />
              <p class="card-text mt-1">
                Banners
              </p>
            </b-card>
          </router-link>
        </feature>
        <feature name="branding">
          <router-link
            tag="p"
            class="tool-link"
            to="/branding">
            <b-card
              v-if="canBrandingView"
              class="zoom-card tool-card flex-column justify-content-center shadow m-2"
              border-variant="primary"
              align="center">
              <i class="card-icon far fa-copyright fa-2x" />
              <p class="card-text mt-1">
                Branding
              </p>
            </b-card>
          </router-link>
        </feature>
        <feature name="calendar-configuration">
          <router-link
            tag="p"
            class="tool-link"
            to="/calendarconfiguration">
            <b-card
              v-if="canScoreboardFlipView"
              class="zoom-card tool-card flex-column justify-content-center shadow m-2"
              border-variant="primary"
              align="center">
              <span class="fa-stack card-icon">
                <i class="fas fa-calendar-day fa-stack-2x" />
                <i
                  class="fas fa-undo fa-stack-1x fa-inverse"
                  style="padding-left:14px; padding-top:10px;" />
              </span>
              <p class="card-text mt-1">
                Calendar Config
              </p>
            </b-card>
          </router-link>
        </feature>
        <feature name="cdmenu">
          <router-link
            tag="p"
            class="tool-link"
            to="/cdmenu">
            <b-card
              v-if="canCDMenuView"
              class="zoom-card tool-card flex-column justify-content-center shadow m-2"
              border-variant="primary"
              align="center">
              <i class="card-icon fas fa-tv fa-2x" />
              <p class="card-text mt-1">
                Connected Devices Menu
              </p>
            </b-card>
          </router-link>
        </feature>
        <feature name="epg-content-config">
          <router-link
            tag="p"
            class="tool-link"
            to="/epgcontentconfig">
            <b-card
              v-if="canEpgContentConfigView"
              class="zoom-card tool-card flex-column justify-content-center shadow m-2"
              border-variant="primary"
              align="center">
              <span class="fa-stack card-icon">
                <i class="fas fa-ticket-alt fa-stack-2x" />
                <i
                  class="fas fa-wrench fa-flip-horizontal fa-stack-1x fa-inverse"
                  style="padding-right:14px; padding-top:4px;" />
              </span>
              <p class="card-text mt-1">
                EPG Configuration Tool
              </p>
            </b-card>
          </router-link>
        </feature>
        <feature name="messages">
          <router-link
            tag="p"
            class="tool-link"
            to="/messages">
            <b-card
              v-if="canMessagesConfigView"
              class="zoom-card tool-card flex-column justify-content-center shadow m-2"
              border-variant="primary"
              align="center">
              <span class="fa-stack card-icon">
                <i class="fas fa-comments fa-stack-2x" />
              </span>
              <p class="card-text mt-1">
                Messages
              </p>
            </b-card>
          </router-link>
        </feature>
        <feature name="paywall">
          <router-link
            tag="p"
            class="tool-link"
            to="/paywall">
            <b-card
              v-if="canPaywallView"
              class="zoom-card tool-card flex-column justify-content-center shadow m-2"
              border-variant="primary"
              align="center">
              <i class="card-icon fas fa-credit-card fa-2x" />
              <p class="card-text mt-1">
                Paywall Config (Deprecated)
              </p>
            </b-card>
          </router-link>
        </feature>
        <feature name="paywall">
          <router-link
            tag="p"
            class="tool-link"
            to="/paywall/v1">
            <b-card
              v-if="canPaywallView"
              class="zoom-card tool-card flex-column justify-content-center shadow m-2"
              border-variant="primary"
              align="center">
              <span class="fa-stack">
                <i class="card-icon fas fa-credit-card fa-stack-2x" />
                <i
                  class="fas fa-burst fa-stack-2x"
                  style="margin-left:14px; margin-top:-10px;" />
                <i
                  class="fas fa-star fa-stack-1x"
                  style="margin-left:14px; margin-top:-10px;color:orange;" />
              </span>
              <p class="card-text mt-1">
                Paywall Config v1
              </p>
            </b-card>
          </router-link>
        </feature>
        <feature name="sponsorship-config">
          <router-link
            tag="p"
            class="tool-link"
            to="/sponsorshipconfig">
            <b-card
              v-if="canSponsorshipConfigView"
              class="zoom-card tool-card flex-column justify-content-center shadow m-2"
              border-variant="primary"
              align="center">
              <span class="fa-stack card-icon">
                <i class="fas fa-money-bill-alt fa-stack-2x" />
              </span>
              <p class="card-text mt-1">
                Sponsorship Config
              </p>
            </b-card>
          </router-link>
        </feature>
        <feature name="stats">
          <router-link
            tag="p"
            class="tool-link"
            to="/stats">
            <b-card
              v-if="canStatsView"
              class="zoom-card tool-card flex-column justify-content-center shadow m-2"
              border-variant="primary"
              align="center">
              <i class="card-icon fas fa-list-ol fa-2x" />
              <p class="card-text mt-1">
                Stats and Standings
              </p>
            </b-card>
          </router-link>
        </feature>
        <feature name="team-mashup">
          <router-link
            tag="p"
            class="tool-link"
            to="/team-mashup">
            <b-card
              v-if="canTeamMashupView"
              class="zoom-card tool-card flex-column justify-content-center shadow m-2"
              border-variant="primary"
              align="center">
              <i class="card-icon fas fa-images fa-2x" />
              <p class="card-text mt-1">
                Team Mashup
              </p>
            </b-card>
          </router-link>
        </feature>
        <feature name="webview">
          <router-link
            tag="p"
            class="tool-link"
            to="/webview">
            <b-card
              v-if="canWebviewView"
              class="zoom-card tool-card flex-column justify-content-center shadow m-2"
              border-variant="primary"
              align="center">
              <i class="card-icon fas fa-link fa-2x" />
              <p class="card-text mt-1">
                Web Views
              </p>
            </b-card>
          </router-link>
        </feature>
        <feature name="mobile-util-pages">
          <router-link
            tag="p"
            class="tool-link"
            to="/mobile-util-pages">
            <b-card
              v-if="canMobileUtilPagesView"
              class="zoom-card tool-card flex-column justify-content-center shadow m-2"
              border-variant="primary"
              align="center">
              <em class="card-icon fas fa-images fa-2x" />
              <p class="card-text mt-1">
                Mobile Util Pages
              </p>
            </b-card>
          </router-link>
        </feature>
        <feature name="string-override">
          <router-link
            tag="p"
            class="tool-link"
            to="/string-override">
            <b-card
              v-if="canStringOverrideView"
              class="zoom-card tool-card flex-column justify-content-center shadow m-2"
              border-variant="primary"
              align="center">
              <em class="card-icon fas fa-edit fa-2x" />
              <p class="card-text mt-1">
                String Override Tool
              </p>
            </b-card>
          </router-link>
        </feature>
        <feature name="gumbo-websocket-driver">
          <router-link
            tag="p"
            class="tool-link"
            to="/gumbo-websocket-driver">
            <b-card
              v-if="canGumboWebSocketDriverDrive"
              class="zoom-card tool-card flex-column justify-content-center shadow m-2"
              border-variant="primary"
              align="center">
              <em class="card-icon fas fa-taxi fa-2x" />
              <p class="card-text mt-1">
                Gumbo Websocket Driver
              </p>
            </b-card>
          </router-link>
        </feature>
        <!--    These last few "dummy" cards are a hack to center the card deck and still keep the last row left justified-->
        <p
          v-for="i in 5"
          :key="i"
          style="visibility: hidden">
          <b-card class="tool-card " />
        </p>
      </b-card-group>
    </b-row>
  </b-container>
</template>

<script>
  import {mapGetters} from 'vuex'
  import feature from '@/feature'

  export default {
    name: 'Home',
    components: {
      feature,
    },
    computed: {
      ...mapGetters([
        'isAdmin',
        'canConfigsView',
        'canScoreboardFlipView',
        'canEpgContentConfigView',
        'canAssetManagerView',
        'canTeamMashupView',
        'canBannersView',
        'canSeasonsView',
        'canSponsorshipConfigView',
        'canWebviewView',
        'canBrandingView',
        'canAppNavigationView',
        'canStatsView',
        'canCDMenuView',
        'canMessagesConfigView',
        'canPaywallView',
        'canMobileUtilPagesView',
        'canStringOverrideView',
        'canGumboWebSocketDriverDrive',
      ]),
    },
  }
</script>

<style>

  .card-holder {
    display: flex;
    justify-content: center;
    font-size: 0.75rem;
    font-weight: 400;
  }

  .card-text > p {
    color: black !important;
    text-decoration: none !important;
    font-style: normal !important;
  }

  .zoom-card {
    background-color: #f7f7f7;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
  }

  .zoom-card:hover {
    transform: scale(1.1);
  }

  .tool-card {
    width: 9rem;
    height: 6rem;
  }

  /* Override position of sort icon in bootstrap table headers */
  th::after {
    position: relative !important;
    display: inline-block !important;
    margin-left: .5rem !important;
    width: .75rem;
  }

  /* Overrides default table ::after icon behavior with new icon */
  .table.b-table > thead > tr > th[aria-sort]::after, .table.b-table > tfoot > tr > th[aria-sort]::after {
    padding-bottom: 0;
  }

</style>
